module.exports = __webpack_public_path__ + "img/pc_footer_bg.1a8fb42.webp";